export const environment = {
    production: true,
    basePathApi: 'https://wondrlink-back.vercel.app/api',
    authPathApi: 'https://wondrlink-back.vercel.app/api/auth',
    geoPathAPI: 'https://api.geoapify.com/v1/geocode/autocomplete',
    geoApiKey: '3b23dc57405b446fbbf29846a2d2b6dd',
};
